import { Component } from '@angular/core';
// import { Routes } from '@angular/router';

// export const routes: Routes = [];
import {
  NgModule
} from '@angular/core';
import {
  Routes,
  RouterModule
} from '@angular/router';
import {
  HomeComponent
} from './home/home.component';
import {
  PrivacyPolicyComponent
} from './privacy-policy/privacy-policy.component';
import {
  TermsComponent
} from './terms/terms.component';
import {
  AboutUsComponent
} from './about-us/about-us.component';
import {
  ContactUsComponent
} from './contact-us/contact-us.component';
import {
  PlagiarismComponent
} from './plagiarism/plagiarism.component';
import {
  SummarizeComponent
} from './summarize/summarize.component';
import {
  TextdetectorComponent
} from './textdetector/textdetector.component';
import {
  ArticalComponent
} from './artical/artical.component';
import {
  ParapharsingComponent
} from './parapharsing/parapharsing.component';
import {
  NotFoundComponent
} from './not-found/not-found.component';
import {
  SigninComponent
} from './signin/signin.component';
import {
  SignupComponent
} from './signup/signup.component';
import {
  ForgotPasswordComponent
} from './forgot-password/forgot-password.component';
// import {
//   DocumentComponent
// } from './document/document.component';
import {
  PricingComponent
} from './pricing/pricing.component';
import {
  OpenfileComponent
} from './openfile/openfile.component';
import {
  AccountsettingComponent
} from './accountsetting/accountsetting.component';
import {
  AccountActivationComponent
} from './account-activation/account-activation.component';
import {
  ResetPasswordComponent
} from './reset-password/reset-password.component';
import {
  HelpcenterComponent
} from './helpcenter/helpcenter.component';
import {
  AuthGuard
} from './auth.guard';
import {
  SidebarComponent
} from './sidebar/sidebar.component';
// import {
//   PlagiarismcheckerproComponent
// } from './plagiarismcheckerpro/plagiarismcheckerpro.component';
// import {
//   ParaphrasingproComponent
// } from './paraphrasingpro/paraphrasingpro.component';
// import {
//   TextsummarizerproComponent
// } from './textsummarizerpro/textsummarizerpro.component';
import {
  AitextproComponent
} from './aitextpro/aitextpro.component';
// import {
//   ArticleproComponent
// } from './articlepro/articlepro.component';
import {
  DictionaryComponent
} from './dictionary/dictionary.component';
import {
  LanguageComponent
} from './language/language.component';
import {
  ShareComponent
} from './share/share.component';
import {
  SavefileComponent
} from './savefile/savefile.component';
import {
  ComposeEmailComponent
} from './compose-email/compose-email.component';
import {
  DownloadComponent
} from './download/download.component';
import {
  FailureComponent
} from './failure/failure.component';
import {
  NotformobileComponent
} from './notformobile/notformobile.component';
import {
  AiJobDescriptionComponent
} from './Tools/ai-job-description/ai-job-description.component';
import {
  AiBusinessPlanComponent
} from './Tools/ai-business-plan/ai-business-plan.component';
import {
  AiSummarizerComponent
} from './Tools/ai-summarizer/ai-summarizer.component';
// import {
//   AiParagraphComponent
// } from './Tools/ai-paragraph/ai-paragraph.component';
import {
  AiLetterWriterComponent
} from './Tools/ai-letter-writer/ai-letter-writer.component';
import {
  GradingComponent
} from './Tools/grading/grading.component';
import {
  AiArticleWriterComponent
} from './Tools/ai-article-writer/ai-article-writer.component';
import {
  SignupwithcardComponent
} from './signupwithcard/signupwithcard.component';
import {
  RecheckpaymentplanComponent
} from './recheckpaymentplan/recheckpaymentplan.component';
import {
  AccountverifiedComponent
} from './accountverified/accountverified.component';
import { SuccessComponent } from './success/success.component';
import { VerifyComponent } from './verify/verify.component';
import { EmailverifyComponent } from './emailverify/emailverify.component';
import { GrammarcheckerComponent } from './grammarchecker/grammarchecker.component';
import { AccountActivationPhoneComponent } from './account-activation-phone/account-activation-phone.component';
import { PunctuationCheckerComponent } from './punctuation-checker/punctuation-checker.component';
import { EditorMobileViewComponent } from './editor-mobile-view/editor-mobile-view.component';
import { HandbookComponent } from './handbook/handbook.component';
import { SentenceCheckerComponent } from './sentence-checker/sentence-checker.component';
import { EasyCheckerComponent } from './easy-checker/easy-checker.component';
import { ProofReaderComponent } from './proof-reader/proof-reader.component';
import { AllToolsComponent } from './Tools/all-tools/all-tools.component';
import { AiBrainstormingComponent } from './Tools/ai-brainstorming/ai-brainstorming.component';
import { CoverletterComponent } from './Tools/coverletter/coverletter.component';
import { AiThesisComponent } from './Tools/ai-thesis/ai-thesis.component';
import { AiPersonalComponent } from './Tools/ai-personal/ai-personal.component';
import { AiBlogWritingComponent } from './Tools/ai-blog-writing/ai-blog-writing.component';
import { AiSlogansComponent } from './Tools/ai-slogans/ai-slogans.component';
import { AiInstagramComponent } from './Tools/ai-instagram/ai-instagram.component';
import { AiBusinessReportComponent } from './Tools/ai-business-report/ai-business-report.component';
import { ValuePropsitionComponent } from './Tools/value-propsition/value-propsition.component';
import { ExecutiveSummaryComponent } from './Tools/executive-summary/executive-summary.component';
import { AiResignationComponent } from './Tools/ai-resignation/ai-resignation.component';
import { EmailGeneratorComponent } from './Tools/email-generator/email-generator.component';
import { CoverLetterComponent } from './Tools/cover-letter/cover-letter.component';
import { ResumeGeneratorComponent } from './Tools/resume-generator/resume-generator.component';
import { ResumeObjectiveComponent } from './Tools/resume-objective/resume-objective.component';
import { EditorComponent } from './editor/editor.component';
// import { EditorMobilesViewComponent } from './editor-mobiles-view/editor-mobiles-view.component'; 
import { AIParagraphGeneratorComponent } from './new-tool-components/ai-paragraph-generator/ai-paragraph-generator.component';
// import { EditorTabViewComponent } from './editor-tab-view/editor-tab-view.component';

import { PlagiarismcheckerComponent } from './plagiarismchecker/plagiarismchecker.component';
import { ParaphraserproComponent } from './paraphraserpro/paraphraserpro.component';
import { ArticlerewriterComponent } from './articlerewriter/articlerewriter.component';
import { TextsummarizerComponent } from './textsummarizer/textsummarizer.component';
// import { AitextdetectorComponent } from './aitextdetector/aitextdetector.component';
import { EditorTabsViewComponent } from './editor-tabs-view/editor-tabs-view.component';
import { HumanizerToolComponent } from './humanizer-tool/humanizer-tool.component';

import { AppHomeComponent } from './app-home/app-home.component';
import { AppArticleRewriteComponent } from './app-article-rewrite/app-article-rewrite.component';
import { AppSummarizeComponent } from './app-summarize/app-summarize.component';
import { AppTextDetectorComponent } from './app-text-detector/app-text-detector.component';
import { AppPlagiarismComponent } from './app-plagiarism/app-plagiarism.component';
import { AppParaphraseComponent } from './app-paraphrase/app-paraphrase.component';
import { ArticleFreeToolComponent } from './article-free-tool/article-free-tool.component';
import { TabTextDetectorComponent } from './tab-text-detector/tab-text-detector.component';
export const routes: Routes = [

  //  {
  //   path: 'app-home',
  //   component: AppHomeComponent, 

  // },
  // {
  //   path: 'app-article-rewriter',
  //   component: AppArticleRewriteComponent, 

  // },
  //  {
  //     path: 'app-summarize',
  //     component: AppSummarizeComponent, 

  //   },
  //   {
  //     path: 'app-content-detector',
  //     component: AppTextDetectorComponent, 

  //   },
  //   {
  //     path: 'app-plagiarism',
  //     component: AppPlagiarismComponent, 

  //   },
  //    {
  //     path: 'app-Paraphrase',
  //     component: AppParaphraseComponent, 

  //   },
  // {
  //   path: 'document/:doc_id',
  //   component: EditorComponent,
  //   data: {
  //     title: 'Document | Grammarin.com',
  //     description: "Document",
  //   }
  // },
  // { path: 'editor-pt', component: ParaphraserproComponent },
  // { path: 'editor-ar', component: ArticlerewriterComponent },
  // { path: 'editor-ts', component: TextsummarizerComponent },
  // { path: 'editor-at', component: AitextdetectorComponent },
  {
    path: 'grammar-check',
    component: EditorComponent,
    data: {
      title: 'Document | Grammarin.com',
      description: "Document",
    }
  },
  // {
  //   path: 'document-tab/:doc_id',
  //   component: EditorTabViewComponent,
  // },
  {
    path: 'document-tab/:doc_id',
    component: EditorTabsViewComponent,
  },
  {
    path: 'document-lite/:doc_id',
    component: EditorMobileViewComponent,
  },
  // {
  //   path: 'document-lite/:doc_id',
  //   component: EditorMobilesViewComponent,
  // },
  // {
  //   path: 'ai-humanizer',
  //   component: HumanizerToolComponent
  // },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: {
      title: 'Privacy Policy | Grammarin.com',
      description: "Learn how we collect, use, and protect your personal information. Your privacy is our top priority!",
      ogUrl: 'https://www.grammarin.com/privacy-policy',
      ogImage: "https://www.grammarin.com/assets/images/logo-header.svg",
      canonical: "https://www.grammarin.com/privacy-policy",
      ogTitle: "Privacy Policy | Grammarin.com",
      ogDescription: "Learn how we collect, use, and protect your personal information. Your privacy is our top priority!",
      twitterTitle: "Privacy Policy | Grammarin.com",
      twitterDescription: "Learn how we collect, use, and protect your personal information. Your privacy is our top priority!"
    }
  },
  {
    path: 'terms-conditions',
    component: TermsComponent,
    data: {
      title: 'Term of Services | Grammarin.com',
      description: "Review the terms and conditions that outline the use of our services. Stay informed and understand your rights and responsibilities.",
      ogUrl: 'https://www.grammarin.com/terms-conditions',
      canonical: "https://www.grammarin.com/terms-conditions",
      ogTitle: "Term of Services | Grammarin.com",
      ogDescription: "Review the terms and conditions that outline the use of our services. Stay informed and understand your rights and responsibilities.",
      twitterTitle: "Term of Services | Grammarin.com",
      twitterDescription: "Review the terms and conditions that outline the use of our services. Stay informed and understand your rights and responsibilities."
    }
  },

  {
    path: 'about-us',
    component: AboutUsComponent,
    data: {
      title: 'About GrammarIn – Driven by Values, Led by Innovation',
      description: "Get to know GrammarIn – a passionate team with a commitment to quality, innovation, and customer satisfaction.",
      ogUrl: 'https://www.grammarin.com/about-us',
      canonical: "https://www.grammarin.com/about-us",
      ogTitle: "About GrammarIn – Driven by Values, Led by Innovation",
      ogDescription: "Get to know GrammarIn – a passionate team with a commitment to quality, innovation, and customer satisfaction.",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Homepage.png",
      twitterTitle: "About GrammarIn – Driven by Values, Led by Innovation",
      twitterDescription: "Get to know GrammarIn – a passionate team with a commitment to quality, innovation, and customer satisfaction."
    }
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    data: {
      title: 'Contact Us | Grammarin.com',
      description: "Discover who we are and what drives us! Learn about our mission, vision, and the values that fuel our journey to deliver excellence.",
      ogUrl: 'https://www.grammarin.com/contact-us',
      canonical: "https://www.grammarin.com/contact-us",
      ogTitle: "Contact Us | Grammarin.com",
      ogDescription: "Discover who we are and what drives us! Learn about our mission, vision, and the values that fuel our journey to deliver excellence.",
      twitterTitle: "Contact Us | Grammarin.com",
      twitterDescription: "Discover who we are and what drives us! Learn about our mission, vision, and the values that fuel our journey to deliver excellence."
    }
  },
  {
    path: 'contact',
    component: ContactUsComponent,
    data: {
      title: 'Contact Us | Grammarin.com',
      description: "Discover who we are and what drives us! Learn about our mission, vision, and the values that fuel our journey to deliver excellence.",
      ogUrl: 'https://www.grammarin.com/contact',
      canonical: "https://www.grammarin.com/contact",
      ogTitle: "Contact Us | Grammarin.com",
      ogDescription: "Discover who we are and what drives us! Learn about our mission, vision, and the values that fuel our journey to deliver excellence.",
      twitterTitle: "Contact Us | Grammarin.com",
      twitterDescription: "Discover who we are and what drives us! Learn about our mission, vision, and the values that fuel our journey to deliver excellence."
    }
  },
  {
    path: 'plagiarism-checker',
    component: PlagiarismComponent,
    data: {
      title: 'Plagiarism Checker Free for Students and Teachers',
      description: "Plagiarism checker is 100% free & accurate online plagiarism detector to check plagiarism and content duplication. Start with 1000 words without sign-up!",
      ogUrl: 'https://www.grammarin.com/plagiarism-checker',
      canonical: "https://www.grammarin.com/plagiarism-checker",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Plagiarism Checker.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "Plagiarism Checker",
      ogTitle: "Plagiarism Checker | Free & 100% Accurate Plagiarism Detector",
      ogDescription: "Grammarin's plagiarism checker is 100% free & accurate online plagiarism detector tool to check plagiarism that helps you to check duplicate content..",
      twitterTitle: "Plagiarism Checker | Free & 100% Accurate Plagiarism Detector",
      twitterDescription: "Grammarin's plagiarism checker is 100% free & accurate online plagiarism detector tool to check plagiarism that helps you to check duplicate content..",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Plagiarism Checker.png"
    }
  },
  {
    path: 'text-summarizer',
    component: SummarizeComponent,
    data: {
      title: 'Text Summarizer | A.I Based Text Summarizing Tool',
      description: "Use our text summarizer which is AI based Summarizing tool to generates summary to summarize long text. Extract the key points with summary generator tool.",
      ogUrl: 'https://www.grammarin.com/text-summarizer',
      canonical: "https://www.grammarin.com/text-summarizer",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Text Summarizer.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "Text Summarizer",
      ogTitle: "Text Summarizer | A.I Based Text Summarizing Tool",
      ogDescription: "Use our text summarizer which is AI based Summarizing tool to generates summary to summarize long text. Extract the key points with summary generator tool.",
      twitterTitle: "Text Summarizer | A.I Based Text Summarizing Tool",
      twitterDescription: "Use our text summarizer which is AI based Summarizing tool to generates summary to summarize long text. Extract the key points with summary generator tool.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Text Summarizer.png"
    }
  },

  {
    path: 'ai-content-detector',
    component: TextdetectorComponent,
    data: {
      title: 'AI Content Detector | AI Text Checker Tool Bard, GPT3 & GPT4 ',
      description: "Grammar In's advanced AI content detector tool can accurately identifies if content is generated ChatGPT, GPT-4, Bard & Claude. Detect the AI content for free.",
      ogUrl: 'https://www.grammarin.com/ai-content-detector',
      canonical: "https://www.grammarin.com/ai-content-detector",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/AI Text Detector.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "AI Content Detector",
      ogTitle: "AI Content Detector | AI Text Checker Tool Bard, GPT3 & GPT4",
      ogDescription: "Grammar In's advanced AI content detector tool can accurately identifies if content is generated ChatGPT, GPT-4, Bard & Claude. Detect the AI content for free.",
      twitterTitle: "AI Content Detector | AI Text Checker Tool Bard, GPT3 & GPT4",
      twitterDescription: "Grammar In's advanced AI content detector tool can accurately identifies if content is generated ChatGPT, GPT-4, Bard & Claude. Detect the AI content for free.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/AI Text Detector.png"
    }
  },
  //   {
  //   path: 'ai-tab-content-detector',
  //   component: TabTextDetectorComponent,
  // },




  // {
  //   path: ':lang/grammar-checker',
  //   component: GrammarcheckerComponent,
  //   data: {
  //     title: 'Grammar Checker Free - (Grammar Editor)',
  //     descrption: "Write with confidence using our free grammar checker. Perfect your grammar style and word choice to eliminate errors in seconds. No sign-up Required.",
  //     ogUrl: 'https://www.grammarin.com/grammar-checker',
  //     canonical: "https://www.grammarin.com/grammar-checker",
  //     ogImage: "https://www.grammarin.com/assets/images/OG-Images/Gramamr-Checker.png",
  //     ogImageType: "image/png",
  //     ogImageWidth: "1200",
  //     ogImageHeight: "627",
  //     ogImageAlt: "Grammar Checker",
  //     ogTitle: "Grammar Checker Free - (Grammar Editor)",
  //     ogDescription: "Write with confidence using our free grammar checker. Perfect your grammar style and word choice to eliminate errors in seconds. No sign-up Required.",
  //     twittertitle: "Grammar Checker Free - (Grammar Editor)",
  //     twitterdescription: "Write with confidence using our free grammar checker. Perfect your grammar style and word choice to eliminate errors in seconds. No sign-up Required.",
  //     twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Gramamr-Checker.png",
  //   }
  // },

  {
    path: 'grammar-checker',
    component: GrammarcheckerComponent,
    data: {
      title: 'Free Grammar Checker - (Grammar Editor)',
      descrption: "Grammar checker Instantly fix writing mistakes of your content! Check grammar, spelling and punctuation errors 100% free without Sign-Up.",
      ogUrl: 'https://www.grammarin.com/grammar-checker',
      canonical: "https://www.grammarin.com/grammar-checker",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Gramamr-Checker.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "Grammar Checker",
      ogTitle: "Free Grammar Checker - (Grammar Editor)",
      ogDescription: "Grammar checker Instantly fix writing mistakes of your content! Check grammar, spelling and punctuation errors 100% free without Sign-Up.",
      twittertitle: "Free Grammar Checker - (Grammar Editor)",
      twitterdescription: "Grammar checker Instantly fix writing mistakes of your content! Check grammar, spelling and punctuation errors 100% free without Sign-Up.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Gramamr-Checker.png",
    }



  },

  // English Route



  {
    path: 'article-rewriter',
    component: ArticalComponent,
    data: {
      title: 'Article Rewriter Tool | Accurate Article & Essay Rewriter',
      description: "Grammarin's article rewriter tool uses advanced AI that helps to rewrite articles & paragraphs. Use this article spinner to create unique content with ease.",
      ogUrl: 'https://www.grammarin.com/article-rewriter',
      canonical: "https://www.grammarin.com/article-rewriter",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Article Rewriter.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "Article Rewriter",
      ogTitle: "Article Rewriter Tool | Accurate Article & Essay Rewriter",
      ogDescription: "Grammarin's article rewriter tool uses advanced AI that helps to rewrite articles & paragraphs. Use this article spinner to create unique content with ease.",
      twitterTitle: "Article Rewriter Tool | Accurate Article & Essay Rewriter",
      twitterDescription: "Grammarin's article rewriter tool uses advanced AI that helps to rewrite articles & paragraphs. Use this article spinner to create unique content with ease.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Article Rewriter.png"
    }
  },

  {
    path: 'free-article-rewriter',
    component: ArticleFreeToolComponent,

  },
  {
    path: 'paraphrasing-tool',
    component: ParapharsingComponent,
    data: {
      title: 'Paraphrasing Tool | Rephrase Text with Best AI Paraphraser',
      description: "Use Grammarin's paraphrasing tool to paraphrase text, essays & articles. Our paraphrase tool uses Advanced AI to reword paragraphs. Paraphrase content now!     ",
      ogUrl: 'https://www.grammarin.com/paraphrasing-tool',
      canonical: "https://www.grammarin.com/paraphrasing-tool",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Paraphrasing Tool.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "Paraphrasing Tool",
      ogTitle: "Paraphrasing Tool | Rephrase Text with Best AI Paraphraser",
      ogDescription: "Use Grammarin's paraphrasing tool to paraphrase text, essays & articles. Our paraphrase tool uses Advanced AI to reword paragraphs. Paraphrase content now!",
      twitterTitle: "Paraphrasing Tool | Rephrase Text with Best AI Paraphraser",
      twitterDescription: "Use Grammarin's paraphrasing tool to paraphrase text, essays & articles. Our paraphrase tool uses Advanced AI to reword paragraphs. Paraphrase content now!",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Paraphrasing Tool.png"
    }
  },
  {
    path: 'signin',
    component: SigninComponent,
    data: {
      title: 'Signin  | Grammarin.com',
      description: "Sign in to access and manage your account settings, and enjoy available tools premium features.",
      ogUrl: 'https://www.grammarin.com/signin',
      canonical: "https://www.grammarin.com/signin",
      ogTitle: "Signin | Grammarin.com",
      ogDescription: "Sign in to access and manage your account settings, and enjoy available tools premium features.",
      twitterTitle: "Signin | Grammarin.com",
      twitterDescription: "Sign in to access and manage your account settings, and enjoy available tools premium features."
    }
  },
  {
    path: 'signup',
    component: SignupComponent,
    data: {
      title: 'Signup  | Grammarin.com',
      description: "Sigup",
      ogUrl: 'https://www.grammarin.com/signup',
      canonical: "https://www.grammarin.com/signup",
      ogTitle: "Sigup | Grammarin.com",
      ogDescription: "Sigup",
      twitterTitle: "Sigup | Grammarin.com",
      twitterDescription: "Sigup"
    }
  },

  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    data: {
      title: 'Forgot Password  | Grammarin.com',
      description: "Forgot Password",
      ogUrl: 'https://www.grammarin.com/forgot-password',
      canonical: "https://www.grammarin.com/forgot-password",
      ogTitle: "Forgot Password | Grammarin.com",
      ogDescription: "Forgot Password",
      twitterTitle: "Forgot Password | Grammarin.com",
      twitterDescription: "Forgot Password"
    }
  },
  // {
  //   path: 'document/:doc_id',
  //   component: EditorComponent,
  //   data: {
  //     title: 'Document | Grammarin.com',
  //     description: "Document",
  //   }
  // },
  {
    path: 'pricing',
    component: PricingComponent,
    data: {
      title: 'Pricing Plans | Grammarin.com',
      description: "Explore our transparent and competitive pricing plans tailored to meet your needs. Find the perfect solution here!",
      ogUrl: 'https://www.grammarin.com/pricing',
      canonical: "https://www.grammarin.com/pricing",
      ogTitle: "Pricing Plans | Grammarin.com",
      ogDescription: "Explore our transparent and competitive pricing plans tailored to meet your needs. Find the perfect solution here!",
      twitterTitle: "Pricing Plans | Grammarin.com",
      twitterDescription: "Explore our transparent and competitive pricing plans tailored to meet your needs. Find the perfect solution here!"
    }
  },
  {
    path: 'openfile',
    component: OpenfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'accountsettings',
    component: AccountsettingComponent,
    canActivate: [AuthGuard],
    data: {
      title: 'Account Settings | Grammarin.com',
      description: "Account Settings",
    }
  },
  {
    path: 'confirm-email/:query1',
    component: AccountActivationComponent,
    data: {
      title: 'Confirm Email | Grammarin.com',
      description: "Confirm Email",
    }
  },
  {
    path: 'confirm-email-phone/:query1',
    component: AccountActivationPhoneComponent,
    data: {
      title: 'Confirm Email | Grammarin.com',
      description: "Confirm Email",
    }
  },
  {
    path: 'resetpassword/:query2',
    component: ResetPasswordComponent,
    data: {
      title: 'Reset Password | Grammarin.com',
      description: "Reset Password",
    }
  },

  {
    path: 'help-center',
    component: HelpcenterComponent,
    data: {
      title: 'Help Center | Grammarin.com',
      description: "Help Center",
      canonical: "https://www.grammarin.com/help-center",
    }
  },
  {
    path: 'failure',
    component: FailureComponent,
    data: {
      title: 'Failure | Grammarin.com',
      description: "Failure",
    }
  },
  {
    path: 'sidebar',
    component: SidebarComponent,
    data: {
      title: 'Sidebar | Grammarin.com',
      description: "Sidebar",
    }
  },
  {
    path: 'plagiarismchecker',
    component: PlagiarismcheckerComponent,
    data: {
      title: 'Plagiarism Checker | Grammarin.com',
      description: "Plagiarism Checker",
    }
  },
  {
    path: 'paraphrasing',
    component: ParaphraserproComponent,
    data: {
      title: 'Paraphrasing | Grammarin.com',
      description: "Paraphrasing",
    }
  },
  {
    path: 'textsummarizer',
    component: TextsummarizerComponent,
    data: {
      title: 'Text Summarizer | Grammarin.com',
      description: "Text Summarizer",
    }
  },
  {
    path: 'aitext/:id',
    component: AitextproComponent,
    data: {
      title: 'AI Text | Grammarin.com',
      description: "AI Text",
    }
  },
  {
    path: 'article',
    component: ArticlerewriterComponent,
    data: {
      title: 'Article | Grammarin.com',
      description: "Article",
    }
  },
  {
    path: 'dictionary',
    component: DictionaryComponent
  },
  {
    path: 'language',
    component: LanguageComponent
  },
  {
    path: 'share',
    component: ShareComponent
  },
  {
    path: 'savefile',
    component: SavefileComponent
  },
  {
    path: 'compose-email',
    component: ComposeEmailComponent
  },
  {
    path: 'download',
    component: DownloadComponent
  },
  {
    path: 'notformobile',
    component: NotformobileComponent,
    data: {
      title: 'Not for Mobile | Grammarin.com',
      description: "Not for Mobile",
    }
  },
  {
    path: 'signupwithcard',
    component: SignupwithcardComponent,
    data: {
      title: 'SignUp with Card | Grammarin.com',
      description: "SignUp with Card",
    }
  },
  { path: 'verifyemail', component: EmailverifyComponent },
  {
    path: 'plans',
    component: RecheckpaymentplanComponent,
    data: {
      title: 'Plans | Grammarin.com',
      description: "Plans",
    }
  },

  {
    path: 'verify-account',
    component: VerifyComponent,
    data: {
      title: 'verify-account | Grammarin.com',
      description: "verify-account",
    }
  },

  {
    path: 'ai-job-description',
    component: AiJobDescriptionComponent,
    data: {
      title: 'Ai Job Description  | Grammarin.com',
      description: "Generate customized job descriptions for any role. Boost your hiring efficiency with our job description generator. No sign-up required.",
      ogUrl: 'https://www.grammarin.com/ai-job-description',
      canonical: "https://www.grammarin.com/ai-job-description",
      ogTitle: "Ai Job Description | Grammarin.com",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/AI Job Description Generator.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogDescription: "Generate customized job descriptions for any role. Boost your hiring efficiency with our job description generator. No sign-up required.",
      twitterTitle: "Ai Job Description | Grammarin.com",
      twitterDescription: "Generate customized job descriptions for any role. Boost your hiring efficiency with our job description generator. No sign-up required."
    }
  },
  {
    path: 'ai-business-plan',
    component: AiBusinessPlanComponent,
    data: {
      title: 'Ai Business Plan  | Grammarin.com',
      description: "Simplify your business planning process with our smart Business Plan Generator. Build a plan tailored to your goals today!",
      ogUrl: 'https://www.grammarin.com/ai-business-plan',
      canonical: "https://www.grammarin.com/ai-business-plan",
      ogTitle: "Ai Business Plan | Grammarin.com",
      ogDescription: "Simplify your business planning process with our smart Business Plan Generator. Build a plan tailored to your goals today!",
      twitterTitle: "Ai Business Plan | Grammarin.com",
      twitterDescription: "Simplify your business planning process with our smart Business Plan Generator. Build a plan tailored to your goals today!"
    }
  },
  {
    path: 'ai-summarizer',

    component: AiSummarizerComponent,
    data: {
      title: 'AI Summarizer  | Grammarin.com',
      description: "AI Summarizer  ",
      ogUrl: 'https://www.grammarin.com/ai-summarizer',
      canonical: "https://www.grammarin.com/ai-summarizer",
      ogTitle: "AI Summarizer | Grammarin.com",
      ogDescription: "AI Summarizer",
      twitterTitle: "AI Summarizer | Grammarin.com",
      twitterDescription: "AI Summarizer"
    }
  },
  // {
  //   path: 'ai-paragraph', component: AiParagraphComponent,
  //   data: {
  //     title: 'AI Paragraph Generator  | Grammarin.com',
  //     description: "Save time and enhance your content with our AI Paragraph Generator. Perfect for students, teachers, bloggers, and many more!",
  //     ogUrl: 'https://www.grammarin.com/ai-paragraph',
  //     canonical: "https://www.grammarin.com/ai-paragraph",
  //     ogTitle: "AI Paragraph Generator | Grammarin.com",
  //     ogDescription: "Save time and enhance your content with our AI Paragraph Generator. Perfect for students, teachers, bloggers, and many more!",
  //     twitterTitle: "AI Paragraph Generator | Grammarin.com",
  //     twitterDescription: "Save time and enhance your content with our AI Paragraph Generator. Perfect for students, teachers, bloggers, and many more!"
  //   }
  // },
  // {
  //   path: 'ai-paragraph-generator',
  //   component: AIParagraphGeneratorComponent,
  //   data: {
  //     title: 'Free AI Paragraph Generator  | Grammarin.com',
  //     description: " AI paragraph generator generate informational, persuasive and conversational paragraphs in seconds. Write unique paragraphs with our paragraph writer for free.",
  //     canonical: "https://www.grammarin.com/ai-paragraph-generator"
  //   }

  // },
  {
    path: 'ai-paragraph',
    redirectTo: 'ai-paragraph-generator',
    pathMatch: 'full'
  },
  {
    path: 'ai-paragraph-generator',
    component: AIParagraphGeneratorComponent,
    data: {
      title: 'Free AI Paragraph Generator  | Grammarin.com',
      description: "AI paragraph generator generates informational, persuasive, and conversational paragraphs in seconds. Write unique paragraphs with our paragraph writer for free.",
      canonical: "https://www.grammarin.com/ai-paragraph-generator"
    }
  },
  {
    path: 'ai-letter-writer', component: AiLetterWriterComponent,
    data: {
      title: 'AI Letter Writer  | Grammarin.com',
      description: "Effortlessly write formal and informal letters with our AI Letter Writer. Ideal for every occasion and purpose!",
      ogUrl: 'https://www.grammarin.com/ai-letter-writer',
      canonical: "https://www.grammarin.com/ai-letter-writer",
      ogTitle: "AI Letter Writer | Grammarin.com",
      ogDescription: "Effortlessly write formal and informal letters with our AI Letter Writer. Ideal for every occasion and purpose!",
      twitterTitle: "AI Letter Writer | Grammarin.com",
      twitterDescription: "Effortlessly write formal and informal letters with our AI Letter Writer. Ideal for every occasion and purpose!"
    }
  },
  {
    path: 'ai-article-writer', component: AiArticleWriterComponent,
    data: {
      title: 'AI Article Writer  | Grammarin.com',
      description: "Simplify your content creation process with our Article Writer. Generate polished and captivating articles instantly. No sign-up, free for all.",
      ogUrl: 'https://www.grammarin.com/ai-article-writer',
      canonical: "https://www.grammarin.com/ai-article-writer",
      ogTitle: "AI Article Writer | Grammarin.com",
      ogDescription: "Simplify your content creation process with our Article Writer. Generate polished and captivating articles instantly. No sign-up, free for all.",
      twitterTitle: "AI Article Writer | Grammarin.com",
      twitterDescription: "Simplify your content creation process with our Article Writer. Generate polished and captivating articles instantly. No sign-up, free for all."
    }
  },
  {
    path: 'grading', component: GradingComponent,
    data: {
      title: 'IELTS / TOFEL Grading  | Grammarin.com',
      description: "Get accurate and reliable IELTS and TOEFL grading with our expert service. Track your progress and improve your score!  ",
      ogUrl: 'https://www.grammarin.com/grading',
      canonical: "https://www.grammarin.com/grading",
      ogTitle: "IELTS / TOFEL Grading   | Grammarin.com",
      ogDescription: "Get accurate and reliable IELTS and TOEFL grading with our expert service. Track your progress and improve your score!",
      twitterTitle: "IELTS / TOFEL Grading   | Grammarin.com",
      twitterDescription: "Get accurate and reliable IELTS and TOEFL grading with our expert service. Track your progress and improve your score! "
    }
  },
  {
    path: 'punctuation-checker',
    component: PunctuationCheckerComponent,
    data: {
      title: "Punctuation Checker Free - GrammarIn",
      description: "GrammarIn’s free punctuation checker helps you fix punctuation, including commas, semicolons and apostrophes mistakes. No sign-up required to get started.",
      canonical: "https://www.grammarin.com/punctuation-checker",
      ogUrl: 'https://www.grammarin.com/punctuation-checker',
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Punctuation-checker.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "Punctuation-checker",
      ogTitle: "Punctuation Checker Free - GrammarIn",
      ogDescription: "GrammarIn’s free punctuation checker helps you fix punctuation, including commas, semicolons and apostrophes mistakes. No sign-up required to get started.",
      twitterTitle: "Punctuation Checker Free - GrammarIn",
      twitterDescription: "GrammarIn’s free punctuation checker helps you fix punctuation, including commas, semicolons and apostrophes mistakes. No sign-up required to get started.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Punctuation-checker.png"
    }
  },
  { path: 'ai-writing-tools', component: AllToolsComponent },
  { path: 'aiBrainstorming', component: AiBrainstormingComponent, },
  { path: 'coverletter', component: CoverletterComponent },
  {
    path: 'thesis-statement-generator', component: AiThesisComponent,
    data: {
      title: "Thesis Statement Generator for Essays & Research Papers",
      description: "Use our thesis statement generator to generate powerful and plagiarism-free thesis statements for academic use. Save time and get A+ grade.",
      canonical: "https://www.grammarin.com/thesis-statement-generator",
      ogUrl: 'https://www.grammarin.com/thesis-statement-generator',
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/AI-Thesis-Statement-Generator.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "AI Thesis Statement Generator",
      ogTitle: "Thesis Statement Generator for Essays & Research Papers",
      ogDescription: "Use our thesis statement generator to generate powerful and plagiarism-free thesis statements for academic use. Save time and get A+ grade.",
      twitterTitle: "Thesis Statement Generator for Essays & Research Papers",
      twitterDescription: "Use our thesis statement generator to generate powerful and plagiarism-free thesis statements for academic use. Save time and get A+ grade.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/AI-Thesis-Statement-Generator.png"
    }

  },
  { path: 'personal-statement-generator', component: AiPersonalComponent },
  {
    path: 'blog-post-generator', component: AiBlogWritingComponent,
    data: {
      canonical: "https://www.grammarin.com/blog-post-generator",
    }
  },
  { path: 'slogan-generator', component: AiSlogansComponent },
  { path: 'instagram-caption-generator', component: AiInstagramComponent },
  { path: 'report-writer', component: AiBusinessReportComponent },
  { path: 'value-proposition', component: ValuePropsitionComponent },
  { path: 'executive-summary', component: ExecutiveSummaryComponent },
  { path: 'resignation-letter-generator', component: AiResignationComponent },
  { path: 'email-writer', component: EmailGeneratorComponent },
  {
    path: 'cover-letter', component: CoverLetterComponent,
    data: {
      title: "AI Cover Letter Generator - Create Job Winning Cover Letters",
      description: "AI cover letter generator helps you create personalized, ATS-friendly cover letters that highlight your skills and impress hiring managers instantly.",
      canonical: "https://www.grammarin.com/cover-letter",
      ogUrl: 'https://www.grammarin.com/cover-letter',
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/cover-letter-generator.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "AI Cover Letter Generator",
      ogTitle: "AI Cover Letter Generator - Create Job Winning Cover Letters",
      ogDescription: "AI cover letter generator helps you create personalized, ATS-friendly cover letters that highlight your skills and impress hiring managers instantly.",
      twitterTitle: "AI Cover Letter Generator - Create Job Winning Cover Letters",
      twitterDescription: "AI cover letter generator helps you create personalized, ATS-friendly cover letters that highlight your skills and impress hiring managers instantly.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/cover-letter-generator.png"
    }
  },
  { path: 'resume-objective-generator', component: ResumeObjectiveComponent },
  { path: 'resume-skills', component: ResumeGeneratorComponent },




  {
    path: 'sentence-checker',
    component: SentenceCheckerComponent,
    data: {
      title: "Sentence Checker (100% Free) - GrammarIn",
      description: "GrammarIn's sentence checker is a free writing assistant that makes your sentence grammatically correct by reviewing it for clarity, style, and word choice.",
      canonical: "https://www.grammarin.com/sentence-checker",
      ogUrl: 'https://www.grammarin.com/sentence-checker',
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/sentence-checker.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "Sentence Checker",
      ogTitle: "Sentence Checker (100% Free) - GrammarIn",
      ogDescription: "GrammarIn's sentence checker is a free writing assistant that makes your sentence grammatically correct by reviewing it for clarity, style, and word choice.",
      twitterTitle: "Sentence Checker (100% Free) - GrammarIn",
      twitterDescription: "GrammarIn's sentence checker is a free writing assistant that makes your sentence grammatically correct by reviewing it for clarity, style, and word choice.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/sentence-checker.png"
    }
  },

  {
    path: 'online-proofreader',
    component: ProofReaderComponent,
    data: {
      title: 'Online Proofreader - Proofread Essays & Papers for Free',
      description: "Online proofreader polish essays, papers and other professional documents instantly. Get quick and accurate suggestions for flawless writing.",
      canonical: "https://www.grammarin.com/online-proofreader",
      ogUrl: 'https://www.grammarin.com/online-proofreader',
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Free-AI-Proofreader.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "Proofreader",
      ogTitle: "Online Proofreader - Proofread Essays & Papers for Free",
      ogDescription: "Online proofreader polish essays, papers and other professional documents instantly. Get quick and accurate suggestions for flawless writing.",
      twitterTitle: "Online Proofreader - Proofread Essays & Papers for Free",
      twitterDescription: "Online proofreader polish essays, papers and other professional documents instantly. Get quick and accurate suggestions for flawless writing.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Free-AI-Proofreader.png"
    }
  },
  {
    path: 'essay-checker',
    component: EasyCheckerComponent,
    data: {
      title: 'Free Essay Checker - Students First Choice',
      description: "Grammarln's free essay checker reviews your essays for grammar, spelling and vocabulary mistakes. Improve your essay with one click essay corrector.",
      canonical: "https://www.grammarin.com/essay-checker",
      ogUrl: 'https://www.grammarin.com/essay-checker',
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Essay-Checker.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "Essay Checker",
      ogTitle: "Free Essay Checker - Students First Choice",
      ogDescription: "Grammarln's free essay checker reviews your essays for grammar, spelling and vocabulary mistakes. Improve your essay with one click essay corrector.",
      twitterTitle: "Free Essay Checker - Students First Choice",
      twitterDescription: "Grammarln's free essay checker reviews your essays for grammar, spelling and vocabulary mistakes. Improve your essay with one click essay corrector.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Essay-Checker.png"
    }

  },

  {
    path: '',
    component: HomeComponent, pathMatch: 'full',

    data: {
      title: 'GrammarIn: Best AI Assistant for All Your Writing Tasks',
      description: "Enhance your writing with GrammarIn's intelligent writing assistant. Improve your writing accuracy and clarity instantly. ",
      ogUrl: 'https://www.grammarin.com',
      canonical: "https://www.grammarin.com",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Homepage.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "GrammarIn",
      ogTitle: "GrammarIn: Best AI Assistant for All Your Writing Tasks",
      ogDescription: "Enhance your writing with GrammarIn's intelligent writing assistant. Improve your writing accuracy and clarity instantly. ",
      twitterTitle: "GrammarIn: Best AI Assistant for All Your Writing Tasks",
      twitterDescription: "Enhance your writing with GrammarIn's intelligent writing assistant. Improve your writing accuracy and clarity instantly. ",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Homepage.png"
    }
  },

  {
    path: 'pt', component: HomeComponent,

    data: {
      title: 'GrammarIn: assistente de IA para suas tarefas de escrita',
      description: "Aprimore sua escrita com o assistente de escrita inteligente do GrammarIn. Melhore a precisão e a clareza da sua escrita instantaneamente.",
      ogUrl: 'https://www.grammarin.com/pt',
      canonical: "https://www.grammarin.com/pt",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Homepage-pt.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "GrammarIn",
      ogTitle: "GrammarIn: assistente de IA para suas tarefas de escrita",
      ogDescription: "Aprimore sua escrita com o assistente de escrita inteligente do GrammarIn. Melhore a precisão e a clareza da sua escrita instantaneamente.",
      twitterTitle: "GrammarIn: assistente de IA para suas tarefas de escrita",
      twitterDescription: "Aprimore sua escrita com o assistente de escrita inteligente do GrammarIn. Melhore a precisão e a clareza da sua escrita instantaneamente.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Homepage-pt.png"
    }


  },
  {
    path: 'es', component: HomeComponent,
    data: {
      title: 'GrammarIn: Asistente de IA para tus tareas de escritura',
      description: "Mejora tu escritura con el asistente de escritura inteligente de GrammarIn. Mejora la precisión y claridad de tu escritura al instante.",
      ogUrl: 'https://www.grammarin.com/es',
      canonical: "https://www.grammarin.com/es",
      ogImage: "https://www.grammarin.com/assets/images/OG-Images/Homepage-es.png",
      ogImageType: "image/png",
      ogImageWidth: "1200",
      ogImageHeight: "627",
      ogImageAlt: "GrammarIn",
      ogTitle: "GrammarIn: Asistente de IA para tus tareas de escritura",
      ogDescription: "Mejora tu escritura con el asistente de escritura inteligente de GrammarIn. Mejora la precisión y claridad de tu escritura al instante.",
      twitterTitle: "GrammarIn: Asistente de IA para tus tareas de escritura",
      twitterDescription: "Mejora tu escritura con el asistente de escritura inteligente de GrammarIn. Mejora la precisión y claridad de tu escritura al instante.",
      twitterImage: "https://www.grammarin.com/assets/images/OG-Images/Homepage-es.png"
    }
  },

  {
    path: 'handbook', component: HandbookComponent,
    data: {
      title: 'Our Go-To Grammar Handbook for Success - GrammarIn',
      canonical: "https://www.grammarin.com/handbook",
      descrption: "Master grammar with our comprehensive grammar handbook. Learn rules, tips, and examples to improve your writing and communication.",
      ogTitle: 'Our Go-To Grammar Handbook for Success - GrammarIn',
      ogDescription: "Master grammar with our comprehensive grammar handbook. Learn rules, tips, and examples to improve your writing and communication.",
      twittertitle: 'Our Go-To Grammar Handbook for Success - GrammarIn',
      twitterdescription: "Master grammar with our comprehensive grammar handbook. Learn rules, tips, and examples to improve your writing and communication.",
      ogUrl: 'https://www.grammarin.com/handbook',
    }
  },
  { path: 'handbook/:catagory', component: HandbookComponent, },
  { path: 'what-are-modifiers', component: HandbookComponent },
  { path: 'what-are-adjectives', component: HandbookComponent },
  { path: 'what-are-determiners', component: HandbookComponent },
  { path: 'what-are-adverbs', component: HandbookComponent },
  { path: 'what-are-articles', component: HandbookComponent },
  { path: 'what-are-conjunction', component: HandbookComponent },
  { path: 'what-are-interjections', component: HandbookComponent },
  { path: 'what-is-brackets', component: HandbookComponent },
  { path: 'what-are-nouns', component: HandbookComponent },
  { path: 'what-are-prepositions', component: HandbookComponent },
  { path: 'what-are-pronouns', component: HandbookComponent },
  { path: 'what-is-a-verb', component: HandbookComponent },
  { path: 'what-are-apostrophes', component: HandbookComponent },
  { path: 'what-is-a-colon', component: HandbookComponent },
  { path: 'what-is-a-comma', component: HandbookComponent },
  { path: 'what-are-dashes', component: HandbookComponent },
  { path: 'what-is-an-ellipsis', component: HandbookComponent },
  { path: 'what-does-exclamation-mark-mean', component: HandbookComponent },
  { path: 'what-is-a-period', component: HandbookComponent },
  { path: 'how-to-do-upside-down-question-mark', component: HandbookComponent },
  { path: 'when-to-use-quotation-marks', component: HandbookComponent },
  { path: 'what-is-a-semicolon', component: HandbookComponent },
  { path: 'what-are-slashes', component: HandbookComponent },
  { path: 'what-is-abbreviation', component: HandbookComponent },
  { path: 'what-are-contractions', component: HandbookComponent },
  { path: 'what-are-spelling-rules', component: HandbookComponent },
  { path: 'what-is-capitalization', component: HandbookComponent },
  { path: 'what-are-compound-words', component: HandbookComponent },
  { path: 'what-are-literary-devices', component: HandbookComponent },
  { path: 'what-is-irony', component: HandbookComponent },
  { path: 'what-is-a-motif', component: HandbookComponent },
  { path: 'what-is-oxymoron', component: HandbookComponent },
  { path: 'what-is-paradox', component: HandbookComponent },
  { path: 'what-is-personification', component: HandbookComponent },
  { path: 'what-is-satire', component: HandbookComponent },
  { path: 'what-is-suspense', component: HandbookComponent },
  { path: 'what-is-a-symbol', component: HandbookComponent },
  { path: 'what-is-verisimilitude', component: HandbookComponent },
  { path: 'what-is-vignette', component: HandbookComponent },
  { path: 'what-is-hyperbole', component: HandbookComponent },
  { path: 'what-are-onomatopoeia-words', component: HandbookComponent },
  { path: 'what-is-an-idiom', component: HandbookComponent },
  { path: 'what-are-collocations', component: HandbookComponent },
  { path: 'what-is-passive-voice-construction', component: HandbookComponent },
  { path: 'what-is-parallelism', component: HandbookComponent },
  { path: 'what-are-metaphors', component: HandbookComponent },
  { path: 'what-are-similes', component: HandbookComponent },
  { path: 'what-are-parentheses', component: HandbookComponent },
  { path: 'what-is-grammar', component: HandbookComponent },
  {
    path: 'accountverified',
    component: AccountverifiedComponent,
    data: {
      title: 'Account Verified | Grammarin.com',
      description: "Account Verified",
    }
  },
  { path: 'success', component: SuccessComponent },
  {
    path: '**',
    component: NotFoundComponent,


    data: {
      title: 'Not Found | Grammarin.com',
      descrption: "Not Found",
      ogUrl: '',
      canonical: "",
      ogImage: "",
      ogImageType: "",
      ogImageWidth: "",
      ogImageHeight: "",
      ogImageAlt: "",
      ogTitle: "",
      ogDescription: " ",
      twittertitle: "",
      twitterdescription: "",
      twitterImage: "",
    }
    // data: {
    //   title: 'Not Found | Grammarin.com',
    //   description: "Not Found",

    // }
  },



  // Add more routes as needed
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
